module.exports = __webpack_public_path__ + "static/img/1.6426925.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/1.png
// module id = g2h8
// module chunks = 0